import ApplicationController from "./application_controller";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import MARKER from "../../components/backoffice/form/content/specifics/service/map/marker.svg";

import {
  TILE_LAYER,
  TILE_LAYER_MIN_ZOOM,
  DEFAULT_ICON,
  DEFAULT_LAYER_ATTRIBUTION,
  OPTIONS,
  DEFAULT_COORDS,
} from "../../components/backoffice/form/content/specifics/service/map/map_config_component";

export default class extends ApplicationController {
  static targets = ["map", "street", "postcode", "city", "latitude", "longitude", "coords"];

  initialize() {
    this.L = L;
  }

  connect() {
    this._buildAddress();
    if (!this.element.querySelector(".accordion-button").classList.contains(".collapsed")) {
      this.element.querySelector(".accordion-button").click();
    }

    if (this.hasMapTarget) {
      this._initMap();
      this._setPicker();
    }
  }

  updatePicker(coords) {
    this._buildAddress();
    this.coordsTarget.value = `SRID=4326;POINT (${coords.lng} ${coords.lat})`;
    this._setPicker();
  }

  // PRIVATE

  _initMap() {
    this.map = L.map(this.mapTarget, OPTIONS).setView(DEFAULT_COORDS);
    this.transportController ||= this.application.getControllerForElementAndIdentifier(this.element, 'bo-transport');

    L.tileLayer(TILE_LAYER, {
      minZoom: TILE_LAYER_MIN_ZOOM,
      attribution: DEFAULT_LAYER_ATTRIBUTION,
    }).addTo(this.map);

    const ICON_PARIS = L.icon({
      iconUrl: MARKER,
      ...DEFAULT_ICON,
    });

    L.Marker.prototype.options.icon = ICON_PARIS;
    this.marker = L.marker(DEFAULT_COORDS, { draggable: true }).addTo(this.map);

    // On dragend Marker func
    this.marker.on("dragend", (e) => {
      const position = e.target.getLatLng();
      this.coords = [position.lat, position.lng];
      this._updateCoords(false);
      this.map.panTo([position.lat, position.lng]);
      this.transportController._requestAPIs(position.lat, position.lng);
    });
  }

  _buildAddress() {
    const street = this.streetTarget.value;
    const postcode = this.postcodeTarget.value;
    const city = this.cityTarget.value;

    this.address = street && postcode && city ? `${street}, ${postcode}, ${city}` : "";
  }

  _setPicker() {
    if (this.coordsTarget.value && this.coordsTarget.value.includes("POINT")) {
      this.coords = this.coordsTarget.value.replace(/(POINT|SRID=4326;|\)|\()/g, "").split(" ").reverse().map((item) => Number(item));
      this._updateCoords(true);
    }
  }

  _updateCoords(shouldUpdateView) {
    if (this.hasMapTarget && shouldUpdateView) {
      this._updateView();
    }

    if (this.hasCoordsTarget && this.address) {
      this.coordsTarget.value = `SRID=4326;POINT (${this.coords[1]} ${this.coords[0]})`;
    }
  }

  _updateView() {
    this.marker.setLatLng(this.coords);
    this.map.setView(this.coords, this.map.getZoom());
  }
}
